import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { MixPanelTrackedLink } from '../MixPaneTrackedLink';

export default function ShortModalLayout({ open, setOpen, title, firstButton = null, secondButton, children }) {

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby={title}
        >
            <DialogTitle>
                {title}
            </DialogTitle>

            <DialogContent>
                <DialogContentText>
                    {children}
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                {firstButton && <MixPanelTrackedLink
                    type="button"
                    label={firstButton.label}
                    context={`${title} Modal`}
                    disabled={firstButton.loading}
                    onClick={firstButton.onClick}
                    sx={{ whiteSpace: 'nowrap' }}>
                    {firstButton.loading ? <CircularProgress size={25} /> : firstButton.label}
                </MixPanelTrackedLink>}

                <MixPanelTrackedLink
                    type="button"
                    label={secondButton?.label || 'Close'}
                    context={`${title} Modal`}
                    onClick={handleClose}>
                    {secondButton?.label || 'Close'}
                </MixPanelTrackedLink>

            </DialogActions>
        </Dialog>
    );
}